import { get, isEmpty } from 'lodash'

import { toLines } from '../../../../common/utils'

import {
  INGREDIENT_SPECIAL_CASE_DEFINITION_DEFAULT_VALUES,
  INGREDIENT_SPECIAL_CASE_TYPES,
} from '../../../constants'

const ingredientSpecialCaseFormInitialValues = ({
  caseDefinition,
  ...rest
} = {}) => {
  if (isEmpty(caseDefinition)) {
    return {
      ...rest,
      type: INGREDIENT_SPECIAL_CASE_TYPES.PARSING_RULE,
      caseDefinition: get(
        INGREDIENT_SPECIAL_CASE_DEFINITION_DEFAULT_VALUES,
        INGREDIENT_SPECIAL_CASE_TYPES.PARSING_RULE,
      ),
    }
  }

  const parsedCaseDefinition = JSON.parse(caseDefinition)

  if (rest.type === INGREDIENT_SPECIAL_CASE_TYPES.IGNORED_COMBINATION) {
    return {
      ...rest,
      caseDefinition: {
        ...parsedCaseDefinition,
        tokens: toLines(parsedCaseDefinition.tokens),
      },
    }
  }

  return {
    ...rest,
    caseDefinition: parsedCaseDefinition,
  }
}

export default ingredientSpecialCaseFormInitialValues
